import { render, staticRenderFns } from "./ChooseDistrict.html?vue&type=template&id=c48bf664&scoped=true&external"
import script from "./ChooseDistrict.vue?vue&type=script&lang=js"
export * from "./ChooseDistrict.vue?vue&type=script&lang=js"
import style0 from "./ChooseDistrict.scss?vue&type=style&index=0&id=c48bf664&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48bf664",
  null
  
)

export default component.exports